import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
const { carbon } = colorsPalettes;

import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BarContainer = styled(BaseFlex)`
    width: 100%;
    height: 25px;
    overflow: hidden;
    margin-top: 22px;
    margin-bottom: 24px;
`;
export const LegendColor = styled.div<{ color: string }>`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 12px;
    background-color: ${({ color }) => color};
`;
export const LegendType = styled.span`
    ${setFontVariant("body2", carbon[500])};
    text-transform: capitalize;
    flex-grow: 1;
`;
export const LegendPercentage = styled.span`
    ${setFontVariant("body2", carbon[500])};
`;
export const NoDataContainer = styled.div<{ width: string; height: string }>`
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    border-radius: 2px;
    background-color: ${colorsPalettes.carbon[50]};
`;
